<app-page-title [heading]="heading" [subheading]="subheading" [icon]="icon" [showButtons]=false></app-page-title>


<div class="row mb-5">

    <div class="col-md-4">
        <img src="./assets/images/scamp/img-tela-inicial-01.jpg" class="img-thumbnail img-fluid">
    </div>
    <div class="col-md-4">
        <img src="./assets/images/scamp/img-tela-inicial-02.jpg" class="img-thumbnail img-fluid">
    </div>
    <div class="col-md-4">
        <img src="./assets/images/scamp/img-tela-inicial-03.jpg" class="img-thumbnail img-fluid">
    </div>
</div>
<div class="row d-flex justify-content-center align-items-center mb-2">
    <h5>Acesso rápido</h5>
</div>
<div class="main-card mb-3 card">
    <div class="card-body">
        <div class="row">

            <div class="col-md-4" *ngIf="this.tipoInstalacao == 'SS' || this.tipoInstalacao == 'SSPT'">
                <div class="dropdown-menu-header">
                    <div class="menu-header-content">
                        <button [routerLink]="['/solicitar-spv']"
                            class="btn-icon-vertical btn-square btn-transition border-0 btn  btn-block btn-outline-primary">
                            <i class="lnr-cog btn-icon-wrapper btn-icon-lg mb-3"></i>Solicitar SS
                        </button>
                    </div>
                </div>
            </div>
            <div class="col-md-4" *ngIf="this.tipoInstalacao == 'SS' || this.tipoInstalacao == 'SSPT'">
                <div class="dropdown-menu-header">
                    <div class="menu-header-content">
                        <button [routerLink]="['/avaliar-spv/']"
                            class="btn-icon-vertical btn-square btn-transition border-0 btn  btn-block btn-outline-primary">
                            <i class="pe-7s-check btn-icon-wrapper btn-icon-lg mb-3"></i>Avaliar/Programar SS
                        </button>
                    </div>
                </div>
            </div>

            <div class="col-md-4" *ngIf="this.tipoInstalacao == 'PT'">
                <div class="dropdown-menu-header">
                    <div class="menu-header-content">
                        <button [routerLink]="['/solicitar-pt']"
                            class="btn-icon-vertical btn-square btn-transition border-0 btn  btn-block btn-outline-primary">
                            <i class="lnr-cog btn-icon-wrapper btn-icon-lg mb-3"></i>Solicitar PT
                        </button>
                    </div>
                </div>
            </div>

            <div class="col-md-4">
                <div class="dropdown-menu-header">

                    <div class="menu-header-content">
                        <button [routerLink]="['/emitir-os']"
                            class="btn-icon-vertical btn-square btn-transition border-0 btn  btn-block btn-outline-primary">
                            <i class="pe-7s-news-paper btn-icon-wrapper btn-icon-lg mb-3"></i>Emitir OS
                        </button>
                    </div>
                </div>
            </div>
            
        </div>
    </div>
</div>

